class MCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("m-cart") || this.closest("m-cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("m-cart-remove-button", MCartRemoveButton);

class MCartTemplate extends HTMLElement {
  constructor() {
    super();
    this.cartUpdateUnsubscriber = undefined;
    this.isCartPage = MinimogSettings.templateName === "cart";
    this.cartDrawerWrapper = document.querySelector("m-cart-drawer");
    this.cartDrawerInner = document.querySelector(".m-cart-drawer__inner");
    this.mainCartItems = this.querySelector("[data-minimog-cart-items]");
    this.cartSubTotal = this.querySelector("[data-cart-subtotal]");
    this.cartDiscount = this.querySelector("[data-minimog-cart-discounts]");
    this.giftWrapping = this.querySelector("[data-minimog-gift-wrapping]");
    this.checkoutBtn = document.getElementById("checkout-btn");
    this.requestQuoteBtn = document.getElementById("request-quote-btn");

    let loadingTarget = this.cartDrawerInner;
    if (this.isCartPage) loadingTarget = document.body;
    this.loading = new MinimogLibs.AnimateLoading(loadingTarget, {
      overlay: loadingTarget,
    });

    this.rootUrl = window.Shopify.routes.root;

    const debouncedOnChange = debounce((event) => {
      if (event.target.name !== "id") {
        this.onChange(event);
      }
    }, 300);
    if (this.isCartPage) {
      this.mainCartItems.addEventListener(
        "change",
        debouncedOnChange.bind(this)
      );
    } else {
      this.addEventListener("change", debouncedOnChange.bind(this));
    }

    MinimogEvents.subscribe(
      MinimogTheme.pubSubEvents.cartUpdate,
      (response) => {
        this.getCart().then((cart) => {
          this.updateCartCount(cart.item_count);
          this.updateCartButtons(cart);
        });
      }
    );

    this.getCart().then((cart) => this.updateCartButtons(cart));
  }

  updateCartCount(itemCount) {
    const cartCounts = document.querySelectorAll(".m-cart-count-bubble");
    cartCounts.forEach((cartCount) => {
      if (itemCount > 0) {
        cartCount.textContent = itemCount;
        cartCount.classList.remove("m:hidden");
      } else {
        cartCount.classList.add("m:hidden");
      }
    });
  }

  updateCartButtons(cart) {
    let checkoutDisabled = false;

    cart.items.forEach((item) => {
      if (
        item.product?.metafields?.custom?.checkout_inactive === true ||
        item.product?.metafields?.custom?.preis_anzeigen === false
      ) {
        checkoutDisabled = true;
      }
    });

    if (this.checkoutBtn) {
      this.checkoutBtn.style.display = "block";
    }
  }

  getCart() {
    return fetch("/cart.js").then((response) => response.json());
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = MinimogEvents.subscribe(
      MinimogTheme.pubSubEvents.cartUpdate,
      (event) => {
        if (event.source === "main-cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );

    // MutationObserver für direkte DOM-Änderungen
    const cartObserver = new MutationObserver(() => {
      this.getCart().then((cart) => this.updateCartButtons(cart));
    });
    const cartElement = document.querySelector("[data-minimog-cart-items]");

    if (cartElement) {
      cartObserver.observe(cartElement, { childList: true, subtree: true });
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onCartUpdate(renderFooter = true) {
    const { routes } = window.MinimogSettings;
    fetch(`${routes.cart}?section_id=cart-template`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const cartItems = html.querySelector("[data-minimog-cart-items]");
        const cartSubTotal = html.querySelector("[data-cart-subtotal]");
        const cartDiscount = html.querySelector(
          "[data-minimog-cart-discounts]"
        );
        const giftWrapping = html.querySelector("[data-minimog-gift-wrapping]");

        if (this.isCartPage) {
          this.mainCartItems.innerHTML = cartItems.innerHTML;
          if (renderFooter) {
            this.cartSubTotal.innerHTML = cartSubTotal.innerHTML;
            this.cartDiscount.innerHTML = cartDiscount.innerHTML;
            this.giftWrapping.innerHTML = giftWrapping.innerHTML;
          }
        }

        // Buttons direkt nach dem Update aktualisieren
        this.getCart().then((cart) => this.updateCartButtons(cart));
      })
      .catch((e) => {
        console.error(e);
      });
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  updateQuantity(line, quantity, name) {
    this.loading.start();
    const { routes } = window.MinimogSettings;

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          this.loading.finish();
          return;
        }

        this.classList.toggle("m-cart--empty", parsedState.item_count === 0);
        if (this.cartDrawerWrapper)
          this.cartDrawerWrapper.classList.toggle(
            "m-cart--empty",
            parsedState.item_count === 0
          );

this.getSectionsToRender().forEach((section) => {
  const elementToReplace =
    document
      .getElementById(section.id)
      .querySelector(section.selector) ||
    document.getElementById(section.id);
  elementToReplace.innerHTML = this.getSectionInnerHTML(
    parsedState.sections[section.section],
    section.selector
  );
});

//  DOM ist aktualisiert – jetzt Buttons erneut erzwingen
this.getCart().then((cart) => {
  this.updateCartButtons(cart);
  // Sicherstellen, dass cart:updated auch gezündet wird
  document.dispatchEvent(new CustomEvent("cart:updated"));
});


        MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
          ...parsedState,
          source: "main-cart-items",
        });
      })
      .catch(() => {})
      .finally(() => {
        this.loading.finish();
      });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: "[data-minimog-cart-items]",
      },
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: "[data-cart-subtotal]",
      },
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: "[data-minimog-cart-discounts]",
      },
      {
        id: "MinimogCart",
        section: "cart-template",
        selector: "[data-minimog-gift-wrapping]",
      },
    ];
  }
}

customElements.define("m-cart", MCartTemplate);

document.addEventListener("DOMContentLoaded", function () {
  function updateCartButtons() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        let checkoutDisabled = false;

        cart.items.forEach((item) => {
          if (
            item.product?.metafields?.custom?.checkout_inactive === true ||
            item.product?.metafields?.custom?.preis_anzeigen === false
          ) {
            checkoutDisabled = true;
          }
        });

        const checkoutBtn = document.getElementById("checkout-btn");
        if (checkoutBtn) {
          // checkoutBtn.style.display = checkoutDisabled ? "none" : "block";
        }
      });
  }

  // 🛠️ Shopify `cart:updated` Event nutzen
  document.addEventListener("cart:updated", updateCartButtons);

  // 🛠️ Fallback für alle Fälle (nach Warenkorb-Änderungen)
  setInterval(updateCartButtons, 5000);
});
